/**
 * 时间秒数格式化
 * @param s  时间戳（单位：秒）
 * @returns {*} 格式化后的时分秒
 */
const sec_to_time = (s: number) => {
    var t: any;
    if(s > -1){
        var hour = Math.floor(s/3600);
        var min = Math.floor(s/60) % 60;
        var sec = s % 60;
        if(hour < 10) {
            t = '0'+ hour + ":";
        } else {
            t = hour + ":";
        }

        if(min < 10){t += "0";}
        t += min + ":";
        if(sec < 10){t += "0";}
        t += sec.toFixed(0);
    }
    return t;
}

const isIOS = () => {
    const u = navigator.userAgent, app = navigator.appVersion;
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    return isIOS;
}

const isAndroid = () => {
    const u = navigator.userAgent, app = navigator.appVersion;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    return isAndroid;
}

const GetQueryString = (query: string,name: string) => { 
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)","i"); 
    var r = query.substr(1).match(reg); 
    if (r!=null) return (r[2]); return null; 
}

export { sec_to_time, isIOS, isAndroid, GetQueryString }